import { useEffect, useState } from 'react';
import { BandwidthStatusEnum, useBandwidthContext } from '../contexts/BandwidthContext';

const DEFAULT_TIMEOUT = 5000;

/**
 * @param pending A state linked with the pending status of any "slow" task
 * @param timeoutDuration Max pending duration before `isTimedOut` becomes `true`
 * @returns A state to indicate if the pending duration has exceeded the timeout duration, and a function to reset it
 */
export const useTimeoutError = (pending: boolean, timeoutDuration = DEFAULT_TIMEOUT) => {
  const [isTimedOut, setIsTimedOut] = useState(false);
  const { setStatus } = useBandwidthContext();

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (pending && !isTimedOut) {
      timeout = setTimeout(() => {
        setIsTimedOut(true);
        setStatus(BandwidthStatusEnum.Offline);
      }, timeoutDuration);
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [pending, isTimedOut, timeoutDuration, setStatus]);

  const reset = () => setIsTimedOut(false);

  return { isTimedOut, reset };
};
